<script setup lang="ts">
import { useSlots } from 'vue';

const slots = useSlots();
</script>

<template>
  <div class="itp-widget-card card">
    <div v-if="slots.header" class="card-header">
      <slot name="header" />
    </div>

    <div v-if="slots.content" class="card-content p-4 h-100 shadow-sm">
      <slot name="content" />
    </div>

    <div class="shadow-sm">
      <slot />
    </div>
  </div>
</template>

